import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-alert-box',
  templateUrl: './alert-box.component.html',
  styleUrls: ['./alert-box.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AlertBoxComponent {
  @Input() type: 'info'|'success'|'warning'|'error' = 'info';
  @Input() messageLine = '';
  @Input() buttonText = '';
  @Input() showSpinner = false;
  @Output() buttonClicked: EventEmitter<any> = new EventEmitter();

  buttonClickedHandler(event: any): void {
    this.buttonClicked.emit(event);
  }
  constructor() { }
}
